import React, { Component, Fragment } from 'react';
import Helmet from 'react-helmet';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { push } from 'connected-react-router/immutable';
import { routes } from 'config/routes';
import { Creators as AuthCreators } from 'store/ducks/auth';

// import Title from 'components/Title';
// import Button from 'components/Button';
// import SpotlightImage from 'components/SpotlightImage';
// import StyledLink from 'components/StyledLink';

// import { forgotPasswordSendEmail, clearForgotPassword } from 'reducers/auth/actions';

import {
  Container, BoxRecovery, Icon, Title, Desc, StyledButtonTriider,
} from './styles';

class ConfirmEmail extends Component {
  constructor(props) {
    super(props);

    this.resend = this.resend.bind(this);
    this.redirect = this.redirect.bind(this);
  }

  resend() {
    const { email, _forgotPasswordSendEmail } = this.props;

    _forgotPasswordSendEmail({ email, resend: true });
  }

  redirect() {
    const { isPassword, _push } = this.props;
    if (isPassword) _push(routes.locals);
    else _push(routes.home);
  }

  render() {
    const { isLoading, isPassword } = this.props;

    return (
      <Container>
        <Helmet title="Triider - Recuperar senha" />
        <BoxRecovery>
          { isPassword ? <Icon type="password" /> : <Icon type="email" /> }
          <Title>{ isPassword ? 'Senha nova criada com sucesso!' : 'Confira o seu e-mail!' }</Title>
          <Desc>
            { isPassword
              ? 'Pronto! Agora é só fazer o seu pedido e deixar a resolução do problema com a gente!'
              : 'Enviamos um link para você recuperar a sua senha!' }
          </Desc>
          {
            !isPassword && (
              <StyledButtonTriider
                size="fullBlock"
                isLoading={isLoading}
                onClick={this.resend}
                outlined
              >
                Reenviar e-mail
              </StyledButtonTriider>
            )
          }

          <StyledButtonTriider
            size="fullBlock"
            isLoading={isLoading}
            onClick={this.redirect}
          >
            { isPassword ? 'Voltar para o início' : 'Voltar para o login' }
          </StyledButtonTriider>
        </BoxRecovery>
      </Container>
    );
  }
}

const mapStateToProps = state => ({
  loadingVisible: state.ui.loaders.includes('RECOVERY_PASSWORD'),
  isPassword: state.auth.isPassword,
  email: state.auth.email,
});

const mapDispatchToProps = {
  _forgotPasswordSendEmail: AuthCreators.forgotPasswordSendEmailrequest,
  _push: push,
  // _clearForgotPassword: clearForgotPassword,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ConfirmEmail);
